/**
 * Created by Rodrigo Quesada on 09/04/17.
 */
import {NgModule} from '@angular/core';
import {DashboardPageComponent} from './dashboard-page.component';
import {PageCommonModule} from '../shared/page-common.module';

@NgModule({
    imports: [PageCommonModule],
    declarations: [DashboardPageComponent]
})
export class DashboardPageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/dashboard/dashboard-page.module.ts